class RiderWallCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.previousButton = this.querySelector('[data-carousel-previous]');
    this.nextButton = this.querySelector('[data-carousel-next]');

    if (!this.track || !this.previousButton || !this.nextButton) return;

    this.handlePrevious = () => this.move(-1);
    this.handleNext = () => this.move(1);
    this.handlePositionChange = () => this.updateControls();

    this.previousButton.addEventListener('click', this.handlePrevious);
    this.nextButton.addEventListener('click', this.handleNext);
    this.track.addEventListener('scroll', this.handlePositionChange, { passive: true });

    this.resizeObserver = new ResizeObserver(this.handlePositionChange);
    this.resizeObserver.observe(this.track);
    requestAnimationFrame(this.handlePositionChange);
  }

  disconnectedCallback() {
    this.previousButton?.removeEventListener('click', this.handlePrevious);
    this.nextButton?.removeEventListener('click', this.handleNext);
    this.track?.removeEventListener('scroll', this.handlePositionChange);
    this.resizeObserver?.disconnect();
  }

  move(direction) {
    const firstCard = this.track.querySelector('.rider-wall__card');
    if (!firstCard) return;

    const styles = getComputedStyle(this.track);
    const gap = Number.parseFloat(styles.columnGap) || 0;
    const cardWidth = firstCard.getBoundingClientRect().width;
    const visibleCards = Math.max(1, Math.round(this.track.clientWidth / (cardWidth + gap)));
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.track.scrollBy({
      left: direction * (cardWidth + gap) * visibleCards,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  }

  updateControls() {
    const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const hasOverflow = maximumScroll > 2;
    const currentScroll = Math.abs(this.track.scrollLeft);

    this.dataset.overflow = hasOverflow ? 'true' : 'false';
    this.previousButton.disabled = !hasOverflow || currentScroll <= 2;
    this.nextButton.disabled = !hasOverflow || currentScroll >= maximumScroll - 2;
  }
}

if (!customElements.get('rider-wall-carousel')) {
  customElements.define('rider-wall-carousel', RiderWallCarousel);
}
